import { render } from "./Badges.vue?vue&type=template&id=64dabff4"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"
script.render = render

export default script